import PageWithDrawer from './PageWithDrawer';

export default PageWithDrawer;
